import { Directive, AfterContentInit, ElementRef, OnDestroy, inject } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { HisUiService } from '../service/base/his-ui.service';

/**
 * Sets page title based on a h1-element
 */
@Directive( {
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'h1',
    standalone: false
} )
export class HisPageTitleDirective implements AfterContentInit, OnDestroy {
    private el = inject(ElementRef);
    private titleService = inject(Title);
    private hisUiService = inject(HisUiService);



    ngAfterContentInit() {
        // Our host element is a native h1-tag. Therefore Angular change detection
        // is not available in this directive and we have to use a native MutationObserver.
        let observer = new MutationObserver( () => {
            this.updateTitle();
        } );
        let config = { characterData: true, childList: true, subtree: true };
        observer.observe( this.el.nativeElement, config );
        this.updateTitle();
    }


    ngOnDestroy() {
        this.updateTitle();
    }


    private findFirstAngularH1(): HTMLElement {
        let firstAngularH1Element: HTMLElement;
        let allH1Elements = document.querySelectorAll( 'h1' );

        // JSF navigation may contain a h1 with a class sessionTimeoutAccessibilityTitle,
        // which we need to ignore. (it is defined in popup-login.xhtml)
        allH1Elements.forEach( ( h1Elem ) => {
            if ( h1Elem.className !== 'sessionTimeoutAccessibilityTitle' && !firstAngularH1Element ) {
                firstAngularH1Element = h1Elem;
            }
        } );

        return firstAngularH1Element;
    }


    private updateTitle() {
        // We use the first suitable H1 element of this page,
        // not the one this instance of the directive is linked to. For the following reason:

        // For a brief period of time, there might be two h1 elements. Then first one is removed
        // which triggeres the ngOnDestroy callback of that element. But no callback is triggered
        // on the remaining h1, which is now the first one. Therefore we need to use the ngOnDestroy
        // as trigger, but act on the remaining element instead.

        // Furthermore the element, for which ngOnDestroy is invoked, may still exists in the DOM,
        // therefore we use a setTimeout call, to move the processing of this event to the end of
        // the event queque.

        setTimeout(
            () => {
                let element = this.findFirstAngularH1();
                if ( !element ) {
                    return;
                }

                let title = element.innerText.trim();
                if ( title ) {
                    let suffix = ' - ' + this.hisUiService.translate( 'cs.sys.portal.name' );
                    this.titleService.setTitle( title + suffix );
                }
            },
            1);
    }

}
